import React, { PureComponent } from 'react';
import Input from 'component/input.component';
import Button from 'component/button.component';
import Link from 'component/link.component';
import { resetPassword } from 'store/action/email.action';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import {
  USER_ALTER_PASSWORD_SUCCESS,
  USER_ALTER_PASSWORD_ERROR,
} from 'config/constants';
import { toast } from 'react-toastify';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);
class ResetPasswordModal extends PureComponent {

  state = {
    email: '',
    modalRef: null,
    isOpen: false,
  };

  _onChangeEmail = event => {
    this.setState({ email: event.currentTarget.value });
  };

  _resetPassword = email => {
    resetPassword(email)
      .then(({ type }) => {
        if (type === USER_ALTER_PASSWORD_SUCCESS) {
          toast.success('Senha enviada com sucesso!');
          this.setState({isOpen: false});
        } else if (type === USER_ALTER_PASSWORD_ERROR) {
          toast.error('Não foi possível reenviar a senha. Tente mais tarde.');
          this.setState({isOpen: false});
        }
      })
      .catch(err => {
        toast.error('Não foi possível reenviar a senha. Tente mais tarde.');
      });
  };

  render() {
    const { email } = this.state;

    return (
      <div className="flex-column self-align-center">
        <Link
          className="relative component-focus self-align-center"
          onClick={() => { this.setState({isOpen: true})}}
          text="Esqueceu sua senha?"
          style={{ color: '#1a73e8', margin: '20px 15px 0', border: 'none' }}
        />
        <Dialog 
        onClose={() => { this.setState({isOpen: false})}}
        aria-labelledby="customized-dialog-title"
        open={this.state.isOpen}
        >
        <DialogTitle id="customized-dialog-title" onClose={() => { this.setState({isOpen: false})}}>
          <b>Termos de Uso da Aplicação</b>
        </DialogTitle>
        <DialogContent
          dividers
          style={{ whiteSpace: 'pre-wrap', marginLeft: '20px' }}
        > 
          <Input
              inputProps={{
                placeholder: 'Informe seu email',
                value: email,
                onChange: this._onChangeEmail,
              }}
              iconProps={{
                fontFamily: 'MaterialCommunityIcons',
                name: 'email-outline',
                color: '#AAAAAA',
                size: 23,
              }}
            />
        </DialogContent>
        <DialogActions>
        <Button
          className="align-center justify-center"
          onClick={this._resetPassword}
          text="Enviar"
          style={{
            backgroundColor: '#185335',
            width: 100,
            alignSelf: 'center',
          }}
        />
        </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ResetPasswordModal;
